import { render } from "./HeroText.vue?vue&type=template&id=106d7643"
import script from "./HeroText.vue?vue&type=script&lang=js"
export * from "./HeroText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__